import SalesCodesAndGroup from '../../../components/vehicle/sales_code_and_group'
import SalesCodesStore from '../../../components/vehicle/sales_code_and_group/context/context'

const SalesCodesPage = () => {
  return (
    <SalesCodesStore>
      <SalesCodesAndGroup />
    </SalesCodesStore>
  )
}

export default SalesCodesPage
